import React, { useEffect, useState } from "react";
import {
  Nav,
  NavItem,
  TabContent,
  TabPane,
  NavLink,
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  FormGroup,
  Label,
  Input,
  Button,
  FormFeedback,
  Form,
} from "reactstrap";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { SuccessNotify, ErrorNotify } from "../../shared/Alert";
import * as url from "../../helpers/url_helper";
import { showLoading } from "react-global-loading";

import { getData, postData, postRawData } from "../../helpers/url-request";
import {
  getChecklistDetail,
  getStandardTypes,
  updateChecklist,
} from "../../helpers/backend_helper";

import classnames from "classnames";
import QuestionList from "./QuestionList";

const ChecklistFullDetail = (props) => {
  const [activeTab, setactiveTab] = useState(1);
  const [standardList, setStandardList] = useState([]);

  const [formData, setFormData] = useState({
    id: 0,
    name: "",
    description: "",
    standardTypeId: 0,
  });

  useEffect(() => {
    getStandardTypes()
      .then((res) => {
        if (res.data) {
          setStandardList(res.data);
        }
        showLoading(false);
      })
      .catch((err) => {
        console.log(err);
        showLoading(false);
        ErrorNotify("Error occured while fetching data");
      });

    if (props.detailId && props.detailId > 0) {
      //showLoading(true);
      //getChecklistDetail(props.detailId).then((res) => {
      //    showLoading(false);
      //    if (res.status) {
      //        setFormData(formData => ({
      //            ...formData,
      //            id: res.data.id, name: res.data.name, standardTypeId: res.data.standardTypeId, description: res.data.description
      //        }));
      //    } else {
      //        ErrorNotify(res.message);
      //    }
      //})
    }
  }, []);

  // Form validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      id: props.detailId || 0,
      name: formData.name || "",
      description: formData.description || "",
      standardTypeId: formData.standardTypeId || "",
    },
    onSubmit: async (values) => {
      var _data = {
        id: values.id,
        name: values.name,
        description: values.description,
        standardTypeId: Number(values.standardTypeId),
      };

      showLoading(true);

      updateChecklist(_data)
        .then((res) => {
          showLoading(false);
          if (res.status == true) {
            SuccessNotify("Data updated successfully");
          } else {
            ErrorNotify(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
          showLoading(false);
          ErrorNotify("Error occured while saving data");
        });
    },
  });

  return (
    <React.Fragment>
      <QuestionList
        detailId={props.detailId}
        checklist={props.dataDetail}
        closeAction={props.closeAction}
      />
    </React.Fragment>
  );
};

export default ChecklistFullDetail;
